const experiences = [

  {
    title: "Machine Learning Engineer",
    company_name: "FORTE CLOUD",
    icon: "./company/forte.png",
    iconBg: "#c95bf5",
    date: "Jul 2023 - july 2025",
    link: "",
    points: [
      "Developed and deployed machine learning models for computer vision, speech recognition, and natural language processing (NLP), utilizing LLM techniques to solve complex business challenges.",
      "Specialized in Generative AI using AWS Bedrock for model generation and embedding, and implemented clustering algorithms.",
      "Designed and implemented AWS architecture, optimizing cloud services with EC2, S3, Bedrock, and SageMaker.",
      "Integrated AWS services (e.g., Comprehend, Tesseract, Rekognition) to enhance deployment efficiency and scalability.",
      "Monitored and optimized AWS service costs, ensuring efficient resource usage and cost-effective machine learning solutions.",
      "Created Proof of Concepts (POCs) with Streamlit to demonstrate the potential impact of ML models.",
      "Collaborated with cross-functional teams to deliver robust ML solutions aligned with customer needs and business goals.",
    ],
    link: "https://fortecloud.com/",
  },
  {
    title: "Teacher Assistant",
    company_name: "Ain Shams University",
    icon: "./company/ain.png",
    iconBg: "#c95bf5",
    date: "Jan 2023 - Jun 2023",
    link: "",
    points: [
      "Assisted in teaching computer science and artificial intelligence courses, supporting both theoretical and practical aspects.",
      "Provided guidance to students and faculty, enhancing the learning experience and course effectiveness.",
    ],
    link: "https://cis.asu.edu.eg/",
  },
  {
    title: "Techie Degree Trainee",
    company_name: "Valeo",
    icon: "./company/valeo.png",
    iconBg: "#c95bf5",
    date: "Mar 2023 - Jun 2023",
    link: "",
    points: [
      "Completed a rigorous 3-month training program focusing on Embedded C, SW to HW Interfacing, Automotive Bus Technology, and AUTOSAR.",
      "Gained hands-on experience in automotive technology and embedded systems.",
    ],
    link: "https://www.valeo.com/en/",
  },
  {
    title: "Computer Vision Engineer",
    company_name: "Freelance",
    icon: "./company/free.png",
    iconBg: "#c95bf5",
    date: "Jun 2021 - Feb 2022",

    points: [
      "Developed a computer vision application using OCR and object detection to extract text and identify objects in images.",
      "Implemented edge deployment for local servers and devices, ensuring smooth performance through load testing and Flask.",
      "Built a user-friendly interface with PyQt, demonstrating proficiency in computer vision and application development.",
    ],
  },
];

export default experiences;